import * as React from 'react';
import emailBlueSvg from '../../../../images/emailBlue.svg';
import PageTitle from '../../common/PageTitle';
import { ContentLogoWrapper, ContentLogo, SubTitleParagraph } from '../../common/Layout';

const ForgotPasswordSuccessForm = () => {
	return (
		<>
			<ContentLogoWrapper>
				<ContentLogo src={emailBlueSvg} alt="Email icon" />
			</ContentLogoWrapper>
			<PageTitle title="Password reset link sent" />
			<SubTitleParagraph>
				If an account with that email exists, a password reset link has been sent. Click the link in the email to reset
				your password and log in.
			</SubTitleParagraph>
		</>
	);
};

export default ForgotPasswordSuccessForm;
